import request from "./../utils/request";
import axios from "axios";

export const getWaitingTickets = async ({ page, perPage, tag, assignedUser, platform }) => {
    let queries = {
        page,
        perPage,
        tag,
        assignedUser,
        platform,
    };
    return await request.get("/ticket/waiting/pagination", {
        params: queries,
    });
};

export const getTicketHistory = async (dateBegin, dateEnd, pageCount, perPage, query, assignedUser, rate, status) => {
    const qs = {
        dateBegin,
        dateEnd,
        pageCount,
        perPage,
        query,
        assignedUser,
        rate,
        status,
    };
    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return await request.get("/ticket/history", {
        params: qs,
    });
};

export const assignRep = async ({ _id, repId }) => {
    let data = {
        repId,
        _id,
    };
    return await request.put(`/ticket/${_id}/assignRepresentative`, data);
};

export const sendResponseTicket = async (_id, repId, customerEmail, response, senderMailId) => {
    let data = {
        _id,
        repId,
        customerEmail,
        response,
        senderMailId,
    };
    return await request.put(`/ticket/${_id}/sendResponse`, data);
};

export const getTags = async () => {
    return await request.get("/ticket/getTags");
};

export const getTicketNotifications = async () => {
    return await request.get("/ticket/ticket-notifications");
};
export const addEmailTicketNotification = async (emails, tagFilter) => {
    return await request.put("/ticket/ticket-notifications", { emails, tagFilter });
};

export const removeEmailTicketNotification = async (id) => {
    return await request.delete("/ticket/ticket-notifications/" + id);
};

export const addTicketStatus = async (data) => await request.put(`/ticket/add-status`, data).then((res) => res.data);
export const createTicketStatus = async (data) => await request.put("/ticket-status", data);
export const readTicketStatus = async () => await request.get("/ticket-status");
export const updateTicketStatus = async (data) => await request.patch("/ticket-status", data);
export const deleteTicketStatus = async (id) => await request.delete("/ticket-status/" + id);

export const listTickets = async (filters, cursor) => {
    return await request
        .post("/ticket/list", {
            filters,
            cursor,
        })
        .then((res) => res.data);
};
export const closeTicket = async (ticketId) => {
    return await request.post(`/ticket/${ticketId}/close`).then((res) => res.data);
};

export const deleteMultiTicket = async (ids) => {
    return await request.post(`/ticket/delete-multi`, { ids }).then((res) => res.data);
};
export const TICKET_API = {
    list: listTickets,
    close: closeTicket,
    deleteMultiTicket: deleteMultiTicket,
};


